export const pinsData = (data: any): any => ({
    type: 'PIN_DATA',
    payload: data
});

export const removeChatPin = (appointmentId: any) => ({
    type: 'REMOVE_PIN',
    payload: appointmentId
});
export const closeChatPin = (appointmentId: any) => ({
    type: 'CLOSE_PIN',
    payload: appointmentId
});